export enum JourneyContentRowImageTextIndex {
    Image_Url = 0,
    Header_Text = 1,
    Text_Content = 2
}
